import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import {
    Http,
    RequestOptions,
    RequestOptionsArgs,
    Response,
    Request,
    Headers,
    XHRBackend
} from '@angular/http';

import { AngularReduxRequestOptions } from './angular-redux-request-options';
import { LoaderService } from './loader/loader.service';
import { AuthenticationService } from '../_services/authentication.service';
import { Router } from '@angular/router';
import { AppConfigs } from './../app.config';
import { AlertsService } from 'angular-alert-module';

@Injectable()
export class HttpRequestService extends Http {
    apiUrl: string = AppConfigs.API_ENDPOINT;
    messageInactive = '管理者がアカウントを無効にしました。 アカウントを有効にするには、もう一度管理者にご連絡ください！';
    // apiUrl: string = '/api/';
    // apiUrl: string = 'https://offers.xsrv.jp/api/';

    constructor(backend: XHRBackend, defaultOptions: AngularReduxRequestOptions,
        private loaderService: LoaderService, private router: Router, private alerts: AlertsService) {
        super(backend, defaultOptions);
    }

    public get(url: string, parameter?: any, options?: RequestOptionsArgs): Observable<any> {

        this.showLoader();

        return super.get(this.getFullUrl(url) + this.parseParametersToString(parameter), this.requestOptions(options))
            .catch(this.onCatch)
            .do((res: Response) => {
                this.onSuccess(res);
            }, (error: any) => {
                this.onError(error);
            })
            .finally(() => {
                this.onEnd();
            });
    }

    public delete(url: string, options?: RequestOptionsArgs): Observable<any> {
        this.showLoader();

        return super.delete(this.getFullUrl(url), this.requestOptions(options))
            .catch(this.onCatch)
            .do((res: Response) => {
                this.onSuccess(res);
            }, (error: any) => {
                this.onError(error);
            })
            .finally(() => {
                this.onEnd();
            });
    }

    public put(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
        this.showLoader();
        return super.put(this.getFullUrl(url), body, this.requestOptions(options))
            .catch(this.onCatch)
            .do((res: Response) => {
                this.onSuccess(res);
            }, (error: any) => {
                this.onError(error);
            })
            .finally(() => {
                this.onEnd();
            });
    }

    public post(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
        this.showLoader();
        return super.post(this.getFullUrl(url), body, this.requestOptions(options))
            .catch(this.onCatch)
            .do((res: Response) => {
                this.onSuccess(res);
            }, (error: any) => {
                this.onError(error);
            })
            .finally(() => {
                this.onEnd();
            });
    }

    private requestOptions(options?: RequestOptionsArgs): RequestOptionsArgs {

        if (options == null) {
            options = new AngularReduxRequestOptions();
        }

        if (options.headers == null) {
            options.headers = new Headers();
        }
        // let token = localStorage.getItem('userToken');

        // if (token != null && token != '')
        //     options.headers.append('Authorization', 'Bearer ' + token);
        return options;
    }


    private parseParametersToString(paramter: any) {
        if (paramter == null)
            return '';
        let queryString = `?draw=${paramter.draw}&length=${paramter.length}&start=${paramter.start}`;
        for (var property in paramter.search) {
            if (paramter.search.hasOwnProperty(property)) {
                queryString += `&${property}=${paramter.search[property]}`;
            }
        }

        if (paramter.order && paramter.order.length) {
            let columnIndex = paramter.order[0].column;
            queryString += `&order=${paramter.columns[columnIndex].name}`;
            queryString += `&orderby=${paramter.order[0].dir}`;
        }
        return queryString;
    }

    private getFullUrl(url: string): string {
        return this.apiUrl + url;
    }

    private onCatch(error: any, caught: Observable<any>): Observable<any> {
        return Observable.throw(error);
    }

    private onSuccess(res: Response): void {
        console.log('Request successful');
    }

    private onError(res: Response): void {
        if (res.status == 401) {
            this.router.navigate(["/login"]);
        }

        let resData = res.json();
        if (res.status == 422 && resData.is_inactive) {
            if ((this.router.url != '/login')) {
                this.logout();
                this.router.navigate(["/login"]);
                this.alerts.setDefaults('timeout', 5);
                this.alerts.setMessage(this.messageInactive, 'warn');
            }
        }
        console.log('Error, status code: ' + res.status);
    }

    private onEnd(): void {
        this.hideLoader();
    }

    private showLoader(): void {
        this.loaderService.show();
    }

    private hideLoader(): void {
        this.loaderService.hide();
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('userToken');
        // Remove data current user
        localStorage.removeItem('userCurrent');
    }
}


// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_common/http-request.service.ts